(function () {
  function initPe(root) {
    if (!root || root.dataset.peInitialized === 'true') return;
    root.dataset.peInitialized = 'true';

    var track = root.querySelector('[data-pe-track]');
    var prevBtn = root.querySelector('[data-pe-prev]');
    var nextBtn = root.querySelector('[data-pe-next]');
    var currentEl = root.querySelector('[data-pe-current]');
    var totalEl = root.querySelector('[data-pe-total]');

    if (!track) return;

    function getCardsPerView() {
      var value = parseInt(getComputedStyle(root).getPropertyValue('--pe-cards-per-view'), 10);
      return value > 0 ? value : 1;
    }

    function getStep() {
      var card = track.children[0];
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return (card.getBoundingClientRect().width + gap) * getCardsPerView();
    }

    function getMaxScrollLeft() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function getTotalPages() {
      var step = getStep();
      var maxScroll = getMaxScrollLeft();
      var count = track.children.length;
      if (step <= 0 || maxScroll <= 0) return 1;

      var visibleCards = track.clientWidth / step;
      if (visibleCards < 2) return count;

      return Math.floor(maxScroll / step) + 1;
    }

    function isAtEnd() {
      return track.scrollLeft >= getMaxScrollLeft() - 1;
    }

    function getCurrentPage(totalPages) {
      var step = getStep();
      if (step <= 0) return 1;
      if (isAtEnd()) return totalPages;
      var page = Math.round(track.scrollLeft / step) + 1;
      return Math.min(Math.max(page, 1), totalPages - 1);
    }

    function getScrollForPage(page, totalPages) {
      var step = getStep();
      if (page <= 1) return 0;
      if (page >= totalPages) return getMaxScrollLeft();
      return (page - 1) * step;
    }

    function updatePagination() {
      var totalPages = getTotalPages();
      var page = getCurrentPage(totalPages);

      if (currentEl) currentEl.textContent = page;
      if (totalEl) totalEl.textContent = '/' + totalPages;
      if (prevBtn) prevBtn.disabled = page <= 1;
      if (nextBtn) nextBtn.disabled = isAtEnd();
    }

    var scrollTimeout;

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updatePagination, 80);
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var totalPages = getTotalPages();
        var page = getCurrentPage(totalPages);
        track.scrollTo({ left: getScrollForPage(page - 1, totalPages), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var totalPages = getTotalPages();
        var page = getCurrentPage(totalPages);
        track.scrollTo({ left: getScrollForPage(page + 1, totalPages), behavior: 'smooth' });
      });
    }

    var handleResize = function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updatePagination, 80);
    };
    root.peResizeHandler = handleResize;
    window.addEventListener('resize', handleResize);

    updatePagination();
  }

  function initAll(context) {
    (context || document).querySelectorAll('.pe').forEach(initPe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector('.pe') : null;
    if (root && root.peResizeHandler) {
      window.removeEventListener('resize', root.peResizeHandler);
      root.peResizeHandler = null;
    }
  });
})();
